import { render, staticRenderFns } from "./SnsShare.vue?vue&type=template&id=7e963fe4&"
import script from "./SnsShare.vue?vue&type=script&lang=js&"
export * from "./SnsShare.vue?vue&type=script&lang=js&"
import style0 from "./SnsShare.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports